/**
 * Utility function to convert country names to flag emojis
 */

export const getCountryFlagEmoji = (countryName: string | null): string => {
  if (!countryName) return '';
  
  // Normalize country name to lowercase for matching
  const normalizedCountry = countryName.toLowerCase().trim();
  
  // Map of country names to their flag emojis
  const countryFlagMap: Record<string, string> = {
    // A
    'afghanistan': '🇦🇫',
    'albania': '🇦🇱',
    'algeria': '🇩🇿',
    'andorra': '🇦🇩',
    'angola': '🇦🇴',
    'antigua-and-barbuda': '🇦🇬',
    'argentina': '🇦🇷',
    'armenia': '🇦🇲',
    'australia': '🇦🇺',
    'austria': '🇦🇹',
    'azerbaijan': '🇦🇿',
    
    // B
    'bahamas': '🇧🇸',
    'bahrain': '🇧🇭',
    'bangladesh': '🇧🇩',
    'barbados': '🇧🇧',
    'belarus': '🇧🇾',
    'belgium': '🇧🇪',
    'belize': '🇧🇿',
    'benin': '🇧🇯',
    'bhutan': '🇧🇹',
    'bolivia': '🇧🇴',
    'bosnia-and-herzegovina': '🇧🇦',
    'botswana': '🇧🇼',
    'brazil': '🇧🇷',
    'brunei': '🇧🇳',
    'bulgaria': '🇧🇬',
    'burkina faso': '🇧🇫',
    'burundi': '🇧🇮',
    
    // C
    'cambodia': '🇰🇭',
    'cameroon': '🇨🇲',
    'canada': '🇨🇦',
    'cape verde': '🇨🇻',
    'cape-verde': '🇨🇻',
    'central african republic': '🇨🇫',
    'central-african-republic': '🇨🇫',
    'chad': '🇹🇩',
    'chile': '🇨🇱',
    'china': '🇨🇳',
    'colombia': '🇨🇴',
    'comoros': '🇰🇲',
    'congo': '🇨🇬',
    'costa rica': '🇨🇷',
    'croatia': '🇭🇷',
    'cuba': '🇨🇺',
    'cyprus': '🇨🇾',
    'czech-republic': '🇨🇿',
    
    // D
    'democratic-republic-of-congo': '🇨🇩',
    'denmark': '🇩🇰',
    'djibouti': '🇩🇯',
    'dominica': '🇩🇲',
    'dominican-republic': '🇩🇴',
    
    // E
    'east-timor': '🇹🇱',
    'ecuador': '🇪🇨',
    'egypt': '🇪🇬',
    'el-salvador': '🇸🇻',
    'equatorial-guinea': '🇬🇶',
    'eritrea': '🇪🇷',
    'estonia': '🇪🇪',
    'eswatini': '🇸🇿',
    'ethiopia': '🇪🇹',
    
    // F
    'fiji': '🇫🇯',
    'finland': '🇫🇮',
    'france': '🇫🇷',
    
    // G
    'gabon': '🇬🇦',
    'gambia': '🇬🇲',
    'georgia': '🇬🇪',
    'germany': '🇩🇪',
    'ghana': '🇬🇭',
    'greece': '🇬🇷',
    'grenada': '🇬🇩',
    'guatemala': '🇬🇹',
    'guinea': '🇬🇳',
    'guinea-bissau': '🇬🇼',
    'guyana': '🇬🇾',
    
    // H
    'haiti': '🇭🇹',
    'honduras': '🇭🇳',
    'hungary': '🇭🇺',
    
    // I
    'iceland': '🇮🇸',
    'india': '🇮🇳',
    'indonesia': '🇮🇩',
    'iran': '🇮🇷',
    'iraq': '🇮🇶',
    'ireland': '🇮🇪',
    'israel': '🇮🇱',
    'italy': '🇮🇹',
    'ivory-coast': '🇨🇮',
    'ivory coast': '🇨🇮',
    'cote-d-ivoire': '🇨🇮',
    'cote-divoire': '🇨🇮',
    'cote d\'ivoire': '🇨🇮',
    
    // J
    'jamaica': '🇯🇲',
    'japan': '🇯🇵',
    'jordan': '🇯🇴',
    
    // K
    'kazakhstan': '🇰🇿',
    'kenya': '🇰🇪',
    'kiribati': '🇰🇮',
    'kuwait': '🇰🇼',
    'kyrgyzstan': '🇰🇬',
    
    // L
    'laos': '🇱🇦',
    'latvia': '🇱🇻',
    'lebanon': '🇱🇧',
    'lesotho': '🇱🇸',
    'liberia': '🇱🇷',
    'libya': '🇱🇾',
    'liechtenstein': '🇱🇮',
    'lithuania': '🇱🇹',
    'luxembourg': '🇱🇺',
    
    // M
    'madagascar': '🇲🇬',
    'malawi': '🇲🇼',
    'malaysia': '🇲🇾',
    'maldives': '🇲🇻',
    'mali': '🇲🇱',
    'malta': '🇲🇹',
    'marshall-islands': '🇲🇭',
    'mauritania': '🇲🇷',
    'mauritius': '🇲🇺',
    'mexico': '🇲🇽',
    'micronesia': '🇫🇲',
    'moldova': '🇲🇩',
    'monaco': '🇲🇨',
    'mongolia': '🇲🇳',
    'montenegro': '🇲🇪',
    'morocco': '🇲🇦',
    'mozambique': '🇲🇿',
    'myanmar': '🇲🇲',
    
    // N
    'namibia': '🇳🇦',
    'nauru': '🇳🇷',
    'nepal': '🇳🇵',
    'netherlands': '🇳🇱',
    'new-zealand': '🇳🇿',
    'nicaragua': '🇳🇮',
    'niger': '🇳🇪',
    'nigeria': '🇳🇬',
    'north-korea': '🇰🇵',
    'north-macedonia': '🇲🇰',
    'norway': '🇳🇴',
    
    // O
    'oman': '🇴🇲',
    
    // P
    'pakistan': '🇵🇰',
    'palau': '🇵🇼',
    'panama': '🇵🇦',
    'papua-new-guinea': '🇵🇬',
    'paraguay': '🇵🇾',
    'peru': '🇵🇪',
    'philippines': '🇵🇭',
    'poland': '🇵🇱',
    'portugal': '🇵🇹',
    
    // Q
    'qatar': '🇶🇦',
    
    // R
    'romania': '🇷🇴',
    'russia': '🇷🇺',
    'rwanda': '🇷🇼',
    
    // S
    'saint-kitts-and-nevis': '🇰🇳',
    'saint-lucia': '🇱🇨',
    'saint-vincent-and-grenadines': '🇻🇨',
    'samoa': '🇼🇸',
    'san-marino': '🇸🇲',
    'sao-tome-and-principe': '🇸🇹',
    'saudi-arabia': '🇸🇦',
    'senegal': '🇸🇳',
    'serbia': '🇷🇸',
    'seychelles': '🇸🇨',
    'sierra-leone': '🇸🇱',
    'singapore': '🇸🇬',
    'slovakia': '🇸🇰',
    'slovenia': '🇸🇮',
    'solomon-islands': '🇸🇧',
    'somalia': '🇸🇴',
    'south-africa': '🇿🇦',
    'south africa': '🇿🇦',
    'south-korea': '🇰🇷',
    'south-sudan': '🇸🇸',
    'spain': '🇪🇸',
    'sri-lanka': '🇱🇰',
    'sudan': '🇸🇩',
    'suriname': '🇸🇷',
    'sweden': '🇸🇪',
    'switzerland': '🇨🇭',
    'syria': '🇸🇾',
    
    // T
    'taiwan': '🇹🇼',
    'tajikistan': '🇹🇯',
    'tanzania': '🇹🇿',
    'thailand': '🇹🇭',
    'togo': '🇹🇬',
    'tonga': '🇹🇴',
    'trinidad-and-tobago': '🇹🇹',
    'tunisia': '🇹🇳',
    'turkey': '🇹🇷',
    'turkmenistan': '🇹🇲',
    'tuvalu': '🇹🇻',
    
    // U
    'uganda': '🇺🇬',
    'ukraine': '🇺🇦',
    'united arab emirates': '🇦🇪',
    'united kingdom': '🇬🇧',
    'united-kingdom': '🇬🇧',
    'united states': '🇺🇸',
    'uruguay': '🇺🇾',
    'uzbekistan': '🇺🇿',
    
    // V
    'vanuatu': '🇻🇺',
    'vatican-city': '🇻🇦',
    'venezuela': '🇻🇪',
    'vietnam': '🇻🇳',
    
    // Y
    'yemen': '🇾🇪',
    
    // Z
    'zambia': '🇿🇲',
    'zimbabwe': '🇿🇼',
    
    // Common abbreviations and alternative names
    'usa': '🇺🇸',
    'uk': '🇬🇧',
    'uae': '🇦🇪',
    'us': '🇺🇸',
    'drc': '🇨🇩',
    'dr congo': '🇨🇩'
  };
  
  // Try direct match first
  const directMatch = countryFlagMap[normalizedCountry];
  if (directMatch) {
    return directMatch;
  }
  
  // Try partial matching for cases where location might contain additional info
  for (const [country, flag] of Object.entries(countryFlagMap)) {
    if (normalizedCountry.includes(country) || country.includes(normalizedCountry)) {
      return flag;
    }
  }
  
  // Return empty string if no match found
  return '';
};

/**
 * Helper function to check if a country flag emoji exists for a given country name
 */
export const hasCountryFlag = (countryName: string | null): boolean => {
  return getCountryFlagEmoji(countryName) !== '';
};

/**
 * Alias for getCountryFlagEmoji for backward compatibility
 */
export const getFlagEmoji = getCountryFlagEmoji;